import { core, z } from 'zod';
import { Page } from '@/generic/pagination/domain/Page.ts';
import { Pagination } from '@/generic/pagination/domain/Pagination.ts';

export const pageSchemaOf = <T extends core.SomeType>(contentSchema: T) =>
  z.object({
    currentPage: z.number(),
    pageSize: z.number(),
    totalElementsCount: z.number(),
    content: z.array(contentSchema),
  });

export type PageJson<Content> = {
  currentPage: number;
  pageSize: number;
  totalElementsCount: number;
  content: Content[];
};

export const jsonToPage = <Json, Content>(
  json: PageJson<Json>,
  jsonToContent: (json: Json) => Content,
): Page<Content> =>
  Page.of({
    content: json.content.map(jsonToContent),
    currentPage: json.currentPage + 1,
    pageSize: json.pageSize,
    totalElementsCount: json.totalElementsCount,
  });

export const paginationQuerySchema = z.object({
  page: z.coerce.string(),
  'page-size': z.coerce.string(),
});

export const paginationToQuery = (pagination: Pagination): PaginationQuery =>
  paginationQuerySchema.parse({
    page: pagination.page - 1,
    'page-size': pagination.pageSize,
  });

export type PaginationQuery = z.infer<typeof paginationQuerySchema>;
